// Central preference store for the FinFox header runner.
// One source of truth so the navbar toggle, the profile switch and the
// runner itself can never disagree.

const RUNNER_STORAGE_KEY = "finplay:finfox-runner";
const RUNNER_RELEASE_KEY = "finplay:finfox-runner-v3-visible";
export const FINFOX_RUNNER_EVENT = "finplay:finfox-runner-toggle";

const prefersReducedMotion = () => {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return false;
  }
};

/** Reads the stored preference, defaulting sensibly on first visit. */
export const getFinFoxRunnerEnabled = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    const stored = localStorage.getItem(RUNNER_STORAGE_KEY);
    if (stored === "on") return true;
    if (stored === "off") return false;
    // First visit: on by default, unless the user asked for reduced motion.
    const initial = !prefersReducedMotion();
    localStorage.setItem(RUNNER_RELEASE_KEY, "seen");
    localStorage.setItem(RUNNER_STORAGE_KEY, initial ? "on" : "off");
    return initial;
  } catch {
    return false;
  }
};

/** Sets the preference and notifies every listener in the app. */
export const setFinFoxRunnerEnabled = (on: boolean) => {
  try {
    localStorage.setItem(RUNNER_RELEASE_KEY, "seen");
    localStorage.setItem(RUNNER_STORAGE_KEY, on ? "on" : "off");
  } catch {
    /* storage unavailable — keep the in-memory toggle working */
  }
  window.dispatchEvent(new CustomEvent(FINFOX_RUNNER_EVENT, { detail: { on } }));
};

export const toggleFinFoxRunner = () => {
  const next = !getFinFoxRunnerEnabled();
  setFinFoxRunnerEnabled(next);
  return next;
};

export const subscribeFinFoxRunner = (cb: (on: boolean) => void) => {
  const handler = () => cb(getFinFoxRunnerEnabled());
  window.addEventListener(FINFOX_RUNNER_EVENT, handler);
  window.addEventListener("storage", handler);
  return () => {
    window.removeEventListener(FINFOX_RUNNER_EVENT, handler);
    window.removeEventListener("storage", handler);
  };
};
